import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const resolveUser = () => {
  try {
    const userRaw = localStorage.getItem('user');
    if (userRaw) return JSON.parse(userRaw);
    const authUser = JSON.parse(localStorage.getItem('authUser') || 'null');
    if (authUser?.user) return authUser.user;
    return authUser;
  } catch {
    return null;
  }
};

const resolveRole = (u) => {
  const explicit = (localStorage.getItem('role') || '').toLowerCase();
  return (
    u?.role ||
    u?.user_role ||
    u?.type ||
    explicit ||
    ''
  ).toLowerCase().trim();
};

const RoleGuard = ({
  roles = [],          // الأدوار المسموحة
  redirect = '/dashboard',
  fallback = null,
  children
}) => {
  const location = useLocation();
  const [user, setUser] = useState(() => resolveUser());
  const [role, setRole] = useState(() => resolveRole(resolveUser()));
  const [deciding, setDeciding] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const u = resolveUser();
    const r = resolveRole(u);
    setUser(u);
    setRole(r);

    const allowed = roles.length === 0 || roles.map(rr => rr.toLowerCase()).includes(r);
    setAuthorized(!!u && !!r && allowed);
    setDeciding(false);

  //
  }, [location.pathname, roles]);

  // حالة عدم تسجيل دخول
  if (!deciding && (!user || !role)) {
    return <Navigate to="/login" replace />;
  }

  // قرار نهائي: غير مصرح
  if (!deciding && !authorized) {
    if (fallback) return fallback;
    return (
      <Navigate
        to={redirect}
        replace
        state={{ from: location.pathname, denied: true }}
      />
    );
  }

  // أثناء التحقق (منع وميض الصفحة المحمية)
  if (deciding) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <span className="spinner-border text-primary mb-3" />
        <div className="text-muted">جاري التحقق من الصلاحيات...</div>
      </div>
    );
  }

  return children;
};

export default RoleGuard;
